export const selectIsOverlayerOpened = (state, name) => state.ui.overlayer[name].isOpen;

export default selectIsOverlayerOpened;
